<template>
  <div>
    <div>
      <img
        :title="product.name"
        :src="imageUrl"
        alt="imagen referencial"
        class="img-thumbnail"
        @click="$emit('click-add', product)"
      />
    </div>
    <div class="my-1">
      <button
        v-show="!selected"
        type="button"
        class="btn btn-primary btn-sm mr-1"
        @click="$emit('click-add', product)"
      >
        <i class="fa fa-cart-plus"></i>
      </button>
      <button
        type="button"
        v-show="selected"
        class="btn btn-success btn-sm mr-1"
        @click="$emit('click-add', product)"
      >
        <i class="fa fa-plus"></i>
      </button>
      <button
        type="button"
        v-show="selected"
        class="btn btn-secondary btn-sm mr-1"
        @click="$emit('click-less', product)"
      >
        <i class="fa fa-minus"></i>
      </button>
      <button
        v-show="selected"
        type="button"
        class="btn btn-danger btn-sm"
        @click="$emit('click-remove', product.id)"
      >
        <i class="fa fa-trash"></i>
      </button>
    </div>
    <div v-show="seeName" class="app-product-name">{{ product.name }}</div>
  </div>
</template>
<script>
export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    product: { default: () => ({ id: 0 }) },
    selected: {
      default: false
    },
    seeName: {
      default: false
    }
  },

  data: () => ({
    //
  }),

  computed: {
    imageUrl() {
      if (!this.product.file_id) return "img/noimage.jpeg";
      return `${process.env.VUE_APP_API_URL}/files/${this.product.file_id}`;
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped>
.app-product-name {
  line-height: 1.2;
  font-size: 0.8rem;
}
</style>
